<template>
    <div class="messages-container">
        <div class="message" v-for="(message, index) in messages" :key="index">
            <p v-if="message">{{message.text}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Notificator",
        props: ['messages'],
    }
</script>

<style scoped>

    .message p {
        background: #028f86e8;
        padding: 15px;
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
    }

</style>